import { CreateDecisions } from '../../types';

export const createInputDecisions: CreateDecisions = ({ decisions }) => ({
    color: {
        value: decisions.textColor.font.basic.default,
        state: {
            disabled: {
                value: decisions.textColor.font.secondary.default,
            },
        },
    },
});

export const createInputAffixDecisions: CreateDecisions = ({ decisions }) => ({
    color: {
        value: decisions.textColor.font.secondary.default,
    },
});

export const createInputPlaceholderDecisions: CreateDecisions = ({ decisions }) => ({
    color: {
        value: decisions.textColor.font.secondary.default,
        state: {
            disabled: {
                value: decisions.textColor.font.tertiary.default,
            },
        },
    },
});

export const createInputClearButtonDecisions: CreateDecisions = ({ decisions }) => ({
    color: {
        value: decisions.interactive.basicSecondary.default.default,
        state: {
            hover: {
                value: decisions.interactive.basicSecondary.default.hover,
            },
            active: {
                value: decisions.interactive.basicSecondary.default.active,
            },
        },
    },
});

export const createInputIndicativeIconDecisions: CreateDecisions = ({ decisions }) => ({
    backgroundColor: {
        value: decisions.backgroundColor.surface.medium.default,
    },
});
